import Base from '../../components/base/base';
import { onReady } from '../../shared/utils/helpers';
import ImageWipeSlider from '../../components/image-wipe-slider/image-wipe-slider';
import './biography.scss';

interface BiographyPageOptions {
  debug?: boolean;
  [key: string]: any;
}

export default class BiographyPage extends Base {
  constructor(options: BiographyPageOptions = {}) {
    super(options.debug || false);
    this.init();
  }

  init(): void {
    this.log('Biography page initialized');

    new ImageWipeSlider({
      selector: '.institution-section .biography-gallery .image-carousel',
      slideSelector: '.gallery-collection .image-collection-list .image-collection-item',
      showCredits: true,
      autoplayDelay: 4000,
      transitionDuration: 1.5,
      ease: 'hop',
      waitUntilVisible: true,
      debug: this.debug
    });

    new ImageWipeSlider({
      selector: '.roots-section .roots-block-2 .roots-image-2 .image-carousel',
      slideSelector: '.gallery-collection .image-collection-list .image-collection-item',
      showCredits: false,
      autoplayDelay: 4000,
      transitionDuration: 1.5,
      ease: 'hop',
      waitUntilVisible: true,
      debug: this.debug
    });
  }
}

onReady(() => {
  new BiographyPage({ debug: true });
});
